export class AnnotationRecipeUtils {
  public static getTime(minutes: number): string {
    minutes = Number(minutes * 60);
    const h = Math.floor(minutes / 3600);
    const m = Math.floor(minutes % 3600 / 60);

    const hDisplay = h > 0 ? h + ('H') : '';
    const mDisplay = m > 0 ? m + (h > 0 ? '' : ' min') : '';
    return hDisplay + mDisplay;
  }
}
